var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongDistanceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 27C5.00123 34 13 37 20 37C27.2 37 34.5 33.5 34.9988 27C35.4976 20.5 31 13.5 29 13.5C27 13.5 29 17 27 17C26.1929 17 25.8729 14.7199 25 12C23.71 7.98027 21.7893 3 20 3C18.3567 3 16.1005 8.20064 15 12C14.0914 15.1368 14.3567 17 13 17C11 17 13.0991 13.5 11 13.5C8 13.5 4.99894 20.9867 5 27Z",
    fill: "url(#paint0_linear_6724_113002)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 27.5211L18.9827 19.8651C19.3878 19.1224 20.4748 19.187 20.789 19.9726L22 23H23.8503C24.6013 23 25.0843 23.7968 24.7369 24.4626L20.8488 31.9147C20.4083 32.759 19.1487 32.568 18.9784 31.6311L18.5 29H15.6845C14.9255 29 14.4432 28.1875 14.8066 27.5211Z",
    fill: "#FFF7C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6724_113002",
    x1: 20.0186,
    y1: 3,
    x2: 20.0186,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongDistanceIcon);
export default __webpack_public_path__ + "static/media/long-distance-icon.11f335367e6b90bf038fd0acd72a070f.svg";
export { ForwardRef as ReactComponent };